<template>
  <div>
    <authentication-forms-container :image="image">
      <b-form @submit.prevent="onSubmit" class="mt-2">
        <h4 class="text-primary">تغییر رمز عبور</h4>

        <b-form-row>
          <b-col>
            <form-group :validations="$v.form.password">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-4"
                    label="کلمه عبور"
                    label-for="input-4"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password"
                      type="password"
                      id="input-4"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>

          <b-col>
            <form-group :validations="$v.form.password_confirmation">
              <div slot-scope="{ errors, invalid }">
                <b-form-group
                    id="input-group-5"
                    label="تکرار کلمه عبور"
                    label-for="input-5"
                    class="mb-4"
                >
                  <b-form-input
                      v-model="form.password_confirmation"
                      type="password"
                      id="input-5"
                      placeholder="حداقل ۸ کاراکتر وارد نمایید..."
                      :class="{ invalid }"
                      class="rounded-pill"
                  ></b-form-input>
                  <form-errors-manager :errors="errors"/>
                </b-form-group>
              </div>
            </form-group>
          </b-col>
        </b-form-row>

        <b-button block pill type="submit" class="my-3 w-100" variant="primary"
        >تایید
        </b-button>
      </b-form>
    </authentication-forms-container>
  </div>
</template>

<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import {sameAs, required, minLength, email} from "vuelidate/lib/validators";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import {mapGetters} from "vuex";
import AuthenticationFormsContainer from "../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";
import router from "@/router";

export default {
  name: "EmailForgetPassword",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  data() {
    return {
      form: {
        password: "",
        password_confirmation: "",
      },
    };
  },
  props: {
    image: {
      type: String,
      default: require('../../assets/login.png')
    }
  },
  validations: {
    form: {
      password: {required, minLength: minLength(8)},
      password_confirmation: {required, sameAsPassword: sameAs("password")},
    },
  },
  computed: {
    ...mapGetters({
      emaill: "Authentication/getEmailForForgetPassword",
    }),
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const token = router.currentRoute.params.token.split("=")[1]
        const email = router.currentRoute.params.email.split("=")[1]
        const form = {token: token, email: email, ...this.form};
        console.log(form);
        this.$store.dispatch("Authentication/emailResetPassword", form);
      }
    },
  },
};
</script>
<style scoped></style>
